import { Dispatch, SetStateAction, useEffect } from 'react';

export function useUpdateLoadingState(
  isLoading: boolean,
  setIsLoading: Dispatch<SetStateAction<boolean>>,
  isStreamDone: boolean,
  isDoneRequesting: boolean,
): void {
  useEffect(() => {
    const isStreamingActive = isStreamDone !== undefined && isDoneRequesting !== undefined
      ? (!isStreamDone || !isDoneRequesting)
      : false;

    const shouldBeLoading = isLoading || isStreamingActive;
    setIsLoading(shouldBeLoading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isStreamDone, isDoneRequesting]);
}
